import { Model } from 'pinia-orm';
import { HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Project from './Project';
import SharedFund from './SharedFund';

export default class ProjectGroup extends Model {
  static entity = 'App\\Models\\ProjectGroup';

  @Num(0)
  declare id: number;
  @Num(0)
  declare company_id: number;
  @Str('')
  declare name: string;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  @HasMany(() => Project, 'project_group_id', 'id')
  declare projects: Project[];
  @HasMany(() => SharedFund, 'project_group_id', 'id')
  declare shared_funds: SharedFund[];
}
